import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '../src/assets/styles/btn-styles.css';
import '../src/assets/styles/form-styles.css';
import '../src/assets/styles/table-styles.css';
import '../src/assets/styles/modal-styles.css';
import '../src/assets/styles/file-upload-styles.css';
import reportWebVitals from './reportWebVitals';
import UserLayout from './layouts/UserLayout';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import Login from './pages/Login/Login';
import PrivateRoute from './routes/PrivateRoute';
import RedirectRoute from './routes/RedirectRoute';
import { ToastContainer } from 'react-toastify';
import CustomerSpecialistLayout from './layouts/CustomerSpecialistLayout';
import ManagerLayout from './layouts/ManagerLayout';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ToastContainer />
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={
              <RedirectRoute
                roleRedirects={{
                  admin: "/admin/dashboard",
                  customer_specialist: "/specialist/dashboard",
                  manager: "/manager/dashboard",
                }}
              >
                <Login />
              </RedirectRoute>
            }
          />
          <Route
            path="*"
            element={
              <RedirectRoute
                roleRedirects={{
                  admin: "/admin/dashboard",
                  customer_specialist: "/specialist/dashboard",
                  manager: "/manager/dashboard",
                }}
              >
                <Navigate to="/login" />
              </RedirectRoute>
            }
          />
          <Route
            path="/admin/*"
            element={
              <PrivateRoute
                allowedRoles={["admin"]}
                roleRedirects={{
                  admin: "/admin/dashboard",
                  customer_specialist: "/specialist/dashboard",
                  manager: "/manager/dashboard",
                }}
              >
                <UserLayout />
              </PrivateRoute>
            }
          />
          <Route
            path="/specialist/*"
            element={
              <PrivateRoute
                allowedRoles={["customer_specialist"]}
                roleRedirects={{
                  admin: "/admin/dashboard",
                  customer_specialist: "/specialist/dashboard",
                  manager: "/manager/dashboard",
                }}
              >
                <CustomerSpecialistLayout />
              </PrivateRoute>
            }
          />
           <Route
            path="/manager/*"
            element={
              <PrivateRoute
                allowedRoles={["manager"]}
                roleRedirects={{
                  admin: "/admin/dashboard",
                  customer_specialist: "/specialist/dashboard",
                  manager: "/manager/dashboard",
                }}
              >
                <ManagerLayout />
              </PrivateRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
